import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Label,
  Input,
  FormGroup,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Table,
  Tooltip,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import {
  GET_CATEGORY_DETAILS,
  GET_LICENSE_REQ_DOC,
} from "../../../constants/ApiPaths";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import BackButtonSvg from "../../common/BackButtonSvg";
import { Info } from "../../common/Info";

export default function Viewtemplate() {
  const { categoryId } = useParams();
  const [activeTab, setActiveTab] = useState("1");
  const [loading, setLoading] = useState(false);
  const [formValues, setformValues] = useState([]);
  const [requiredDoc, setrequiredDoc] = useState([]);
  const history = useNavigate();
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const tabtoggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  let Gettemplate = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_CATEGORY_DETAILS,
      headers: authHeader(),
      params: {
        categoryId: categoryId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setformValues(
          JSON.parse(
            data[0].categoryPlaceHolder === "" ||
              data[0].categoryPlaceHolder === null
              ? "[]"
              : data[0].categoryPlaceHolder
          )
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  let GetCategory = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_LICENSE_REQ_DOC,
      headers: authHeader(),
      params: {
        categoryId: categoryId,
      },
    };
    try {
      const response = await API(config);
      const { status, data} = response.data;
      if (status === "Success") {
        setrequiredDoc(data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    Gettemplate();
    GetCategory();
  }, []);
  return (
    <div className="agency-wrapper">
      {loading && <CustomPageLoading />}
      <Container fluid>
        <div className="page-title">
          <h4>Form</h4>

          <div className="top-btn">
            <Button color="primary" onClick={back}>
              <BackButtonSvg />
              Back
            </Button>
          </div>
        </div>
        <div>
          <Nav tabs className="mt-4">
            <NavItem>
              <NavLink
                className={{ active: activeTab === "1" }}
                onClick={() => {
                  tabtoggle("1");
                }}
              >
                Form Preview
                <Tooltip
                  isOpen={id === "formpreview" && tooltipOpen}
                  target={"formpreview"}
                  toggle={() => toggle("formpreview")}
                >
                  Preview form
                </Tooltip>
                <span id={"formpreview"}>
                  <Info />
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={{ active: activeTab === "2" }}
                onClick={() => {
                  tabtoggle("2");
                }}
              >
                Additional Document Preview
                <Tooltip
                  isOpen={id === "docpreview" && tooltipOpen}
                  target={"docpreview"}
                  toggle={() => toggle("docpreview")}
                >
                  Preview additional requested documents
                </Tooltip>
                <span id={"docpreview"}>
                  <Info />
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Container fluid>
                <Row className="mt-5">
                  <Col sm="12" md={{ size: 6, offset: 3 }}>
                    <Card body>
                      <center>
                        <Label>
                          <h5>Form</h5>
                        </Label>
                      </center>
                      {loading === false ? (
                        <>
                          {formValues.length === 0 ? (
                            "No records Found"
                          ) : (
                            <>
                              {formValues.map((f, order) => (
                                <Row>
                                  <Container>
                                    {[
                                      "text",
                                      "textarea",
                                      "date",
                                      "time",
                                    ].includes(f.type) ? (
                                      <FormGroup>
                                        <Label>
                                          {" "}
                                          {order + 1}. {f.label}{" "}
                                          {f.isMandatory ? "*" : ""}
                                        </Label>
                                        <Input
                                          type={f.type}
                                          placeholder={f.placeholder}
                                        ></Input>
                                      </FormGroup>
                                    ) : (
                                      ""
                                    )}
                                    {f.type === "select" ? (
                                      <>
                                        {" "}
                                        <Label>
                                          {order + 1}.{f.label}{" "}
                                          {f.isMandatory ? "*" : ""}
                                        </Label>{" "}
                                        <Input
                                          type={f.type}
                                          placeholder={f.placeholder}
                                        >
                                          {" "}
                                          {f.options.map((o) => (
                                            <option value={o.value}>
                                              {o.label}
                                            </option>
                                          ))}{" "}
                                        </Input>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    {f.type === "radio" ? (
                                      <>
                                        <Label>
                                          {order + 1}.{f.label}{" "}
                                          {f.isMandatory ? "*" : ""}
                                        </Label>
                                        {f.options.map((o, index) => (
                                          <>
                                            <Col sm={10}>
                                              <FormGroup check>
                                                <Label check>
                                                  <Input
                                                    type="radio"
                                                    id=""
                                                    name={f.uniqueId}
                                                  />
                                                  {o.label}{" "}
                                                </Label>
                                              </FormGroup>
                                            </Col>{" "}
                                          </>
                                        ))}
                                      </>
                                    ) : (
                                      ""
                                    )}

                                    {f.type === "checkbox" ? (
                                      <>
                                        <Label>
                                          {order + 1}.{f.label}{" "}
                                          {f.isMandatory ? "*" : ""}
                                        </Label>
                                        {f.options.map((o, index) => (
                                          <>
                                            <Col sm={10}>
                                              <FormGroup check>
                                                <Label check>
                                                  <Input
                                                    type="checkbox"
                                                    id=""
                                                    name={f.uniqueId}
                                                  />
                                                  {o.label}
                                                </Label>
                                              </FormGroup>
                                            </Col>
                                          </>
                                        ))}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </Container>
                                </Row>
                              ))}
                            </>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </Card>
                  </Col>
                </Row>
              </Container>
            </TabPane>
            <TabPane tabId="2">
              <Card body className="mt-5">
                <Row>
                  <Table>
                    <thead>
                      <tr>
                        <th>Document Name</th>
                        <th>Document Description </th>
                        <th>Required</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requiredDoc.length === 0 ? (
                        <tr>
                          <td colSpan={3}>
                            {" "}
                            <center> No Record Found</center>
                          </td>
                        </tr>
                      ) : (
                        <>
                          {requiredDoc.map((req) => (
                            <tr>
                              <td>{req.documentName}</td>
                              <td>
                                {req.documentDescription === ""
                                  ? "-----------------------"
                                  : req.documentDescription}
                              </td>
                              <td>
                                {req.isMandatory === true
                                  ? "Required"
                                  : "Not Required"}
                              </td>
                            </tr>
                          ))}
                        </>
                      )}
                    </tbody>
                  </Table>
                </Row>
              </Card>
            </TabPane>
          </TabContent>
        </div>
      </Container>
    </div>
  );
}
